module.exports = __webpack_public_path__ + "static/og-dc3a3f84113d6e4c49d4515d42c41594.png";